import { api } from './client'

export interface ShippingCarrier {
    id: string
    name: string
    is_active: boolean
    /**
     * `true` = carrier bên ngoài (Viettelpost, GHTK, GHN…) tự vận hành,
     * không dùng ERP. Kế toán được mark delivery status cho đơn của các
     * carrier này thay driver. `false` = carrier in-house ("Tự giao"),
     * driver phải confirm qua flow bình thường.
     */
    is_external: boolean
    /**
     * Mã cố định của hãng hệ thống tự đặt vận đơn (vd `VTP` = Viettel Post).
     * Id dòng khác nhau theo môi trường, tên do người dùng gõ — mã là cách
     * duy nhất nhận ra đúng hãng. Rỗng với đơn vị nội bộ.
     */
    code?: string | null
    created_at: string
    updated_at: string
}

export interface UpsertShippingCarrierRequest {
    name: string
    is_active: boolean
    is_external: boolean
}

export interface ListShippingCarriersParams {
    search?: string
    is_active?: boolean
    page?: number
    per_page?: number
}

export const shippingCarriersApi = {
    list: (params?: ListShippingCarriersParams) =>
        api.get<ShippingCarrier[]>('/shipping-carriers', {
            params: params as Record<
                string,
                string | number | boolean | undefined
            >,
        }),
    getById: (id: string) =>
        api.get<ShippingCarrier>(`/shipping-carriers/${id}`),
    create: (data: UpsertShippingCarrierRequest) =>
        api.post<ShippingCarrier>('/shipping-carriers', data),
    update: (id: string, data: UpsertShippingCarrierRequest) =>
        api.put<ShippingCarrier>(`/shipping-carriers/${id}`, data),
    delete: (id: string) => api.delete(`/shipping-carriers/${id}`),
}
